import { GLOBAL_CONSTANTS } from './constants'

export function isDesktop() {
    const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    if (w > GLOBAL_CONSTANTS.BREAKPOINTS.TABLET) {
        return (true)
    } else {
        return (false)
    }
}